import { render, staticRenderFns } from "./KompasWheel.vue?vue&type=template&id=0e6355b4&"
import script from "./KompasWheel.vue?vue&type=script&lang=js&"
export * from "./KompasWheel.vue?vue&type=script&lang=js&"
import style0 from "./KompasWheel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports